import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceHelper {
  public isIosDevice(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }
}
